import { createSlice } from '@reduxjs/toolkit';
import * as asyncActions from './asyncActions';

export type ProductAdminRole = {
  productName: string;
  role: string;
  helpUrl: string;
};

type State = {
  roles: ProductAdminRole[];
  loading: boolean;
  error: string | null;
};

export const initialState: State = {
  roles: [],
  loading: false,
  error: null,
};

const slice = createSlice({
  name: 'productAdminRole',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(asyncActions.fetchRoles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(asyncActions.fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.roles = action.payload;
      })
      .addCase(asyncActions.fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || 'Failed to fetch product admin roles';
      });
  },
});

export default slice.reducer;
